<script>
import Layout from '../../layouts/auth'
import { authMethods } from "@/state/helpers";

export default {
  components: { Layout },
  data() {
    return {
      username: '',
      password: '',
      submitting: false,
      error: null,
      completed: false,
    }
  },
  computed: {
    customerAsstesDiractory() {
      return process.env.VUE_APP_CUSTOMER_ASSETS_DIRACTORY
    },
    primaryColor() {
      return process.env.VUE_APP_PRIMARY_COLOR || '#556ee6'
    },
  },

  methods: {
    ...authMethods,

    enablePlatform() {
      this.submitting = true
      this.error = null

      return (
        this.disableMaintenance({
        email: this.username,
        password: this.password
      })
        .then(() => {
          this.completed = true

          this.$router.push({
            name: 'default'
          })
        })
        .catch(error => {
          this.error =
            error || 'Identifiants invalides ou droits insuffisants.'
        })
        .finally(() => {
          this.submitting = false
        })

      ); 
    }
  }

}
</script>

<template>
  <Layout class="maintenance-unlock" :style="{ '--maintenance-primary': primaryColor }">
    <main class="maintenance-unlock__page">
      <section class="maintenance-unlock__panel" aria-labelledby="maintenance-title">
        <header class="maintenance-unlock__header">
          <img
            class="maintenance-unlock__logo"
            :src="customerAsstesDiractory + 'logo.png'"
            alt="Plateforme"
          />
          <div class="maintenance-unlock__badge">
            <i class="fas fa-shield-alt" aria-hidden="true"></i>
            Espace s&#233;curis&#233;
          </div>
          <h1 id="maintenance-title">Acc&#232;s administrateur</h1>
          <p>Identifiez-vous pour r&#233;activer la plateforme.</p>
        </header>

        <b-alert v-if="error" show variant="danger" class="maintenance-unlock__alert">
          <i class="fas fa-exclamation-circle mr-2" aria-hidden="true"></i>{{ error }}
        </b-alert>

        <b-alert v-if="completed" show variant="success" class="maintenance-unlock__alert">
          <i class="fas fa-check-circle mr-2" aria-hidden="true"></i>
          Le mode maintenance est d&#233;sactiv&#233;.
        </b-alert>

        <b-form v-if="!completed" @submit.prevent="enablePlatform">
          <b-form-group label="Adresse e-mail" label-for="maintenance-username">
            <b-form-input
              id="maintenance-username"
              v-model="username"
              class="maintenance-unlock__input"
              type="email"
              autocomplete="username"
              placeholder="nom@entreprise.com"
              required
            />
          </b-form-group>

          <b-form-group label="Mot de passe" label-for="maintenance-password">
            <b-form-input
              id="maintenance-password"
              v-model="password"
              class="maintenance-unlock__input"
              type="password"
              autocomplete="current-password"
              placeholder="Votre mot de passe"
              required
            />
          </b-form-group>

          <b-button type="submit" block class="maintenance-unlock__submit" :disabled="submitting">
            <i v-if="submitting" class="fas fa-spinner fa-spin mr-2" aria-hidden="true"></i>
            <i v-else class="fas fa-unlock-alt mr-2" aria-hidden="true"></i>
            Désactiver le mode maintenance
          </b-button>
        </b-form>
      </section>
    </main>
  </Layout>
</template>

<style scoped>
.maintenance-unlock {
  min-height: 100vh;
  background: #f4f7fb;
}

.maintenance-unlock__page {
  display: flex;
  align-items: center;
  justify-content: center;
  min-height: 100vh;
  padding: 32px 16px;
  background: linear-gradient(135deg, rgba(255, 255, 255, .88), rgba(234, 240, 249, .9));
}

.maintenance-unlock__panel {
  width: 100%;
  max-width: 460px;
  padding: 42px;
  background: #fff;
  border: 1px solid #e9edf4;
  border-top: 5px solid var(--maintenance-primary);
  border-radius: 14px;
  box-shadow: 0 18px 45px rgba(41, 52, 76, .12);
}

.maintenance-unlock__header {
  margin-bottom: 32px;
  text-align: center;
}

.maintenance-unlock__logo {
  display: block;
  max-width: 180px;
  max-height: 52px;
  margin: 0 auto 28px;
  object-fit: contain;
}

.maintenance-unlock__badge {
  display: inline-flex;
  align-items: center;
  gap: 7px;
  margin-bottom: 12px;
  color: var(--maintenance-primary);
  font-size: 11px;
  font-weight: 700;
  letter-spacing: .08em;
  text-transform: uppercase;
}

.maintenance-unlock__header h1 {
  margin: 0 0 9px;
  color: #2a3042;
  font-size: 25px;
  font-weight: 700;
}

.maintenance-unlock__header p {
  margin: 0;
  color: #74788d;
  font-size: 14px;
}

.maintenance-unlock__alert {
  border: 0;
  border-radius: 8px;
  font-size: 13px;
}

.maintenance-unlock /deep/ label {
  margin-bottom: 8px;
  color: #495057;
  font-size: 13px;
  font-weight: 600;
}

.maintenance-unlock__input {
  height: 45px;
  border-color: #dfe4ec;
  border-radius: 7px;
}

.maintenance-unlock__input:focus {
  border-color: var(--maintenance-primary);
  box-shadow: 0 0 0 .2rem rgba(85, 110, 230, .12);
}

.maintenance-unlock__submit {
  height: 46px;
  margin-top: 14px;
  color: #fff;
  background: var(--maintenance-primary);
  border-color: var(--maintenance-primary);
  border-radius: 7px;
  font-weight: 600;
}

.maintenance-unlock__submit:hover,
.maintenance-unlock__submit:focus,
.maintenance-unlock__submit:active {
  color: #fff;
  background: var(--maintenance-primary) !important;
  border-color: var(--maintenance-primary) !important;
  box-shadow: 0 6px 16px rgba(41, 52, 76, .18) !important;
}

@media (max-width: 575.98px) {
  .maintenance-unlock__page {
    padding: 18px;
  }

  .maintenance-unlock__panel {
    padding: 32px 24px;
  }
}
</style>


